import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	Invoice,
	ProfessionalPlan,
	ProfessionalSubscription,
	ProfessionalSubscriptionResponse,
} from 'app/interfaces/subscription.interface';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

import { DataLayerService } from './datalayer.service';

export interface SubscribeResponse {
	invoice: Invoice;
	subscription: ProfessionalSubscription;
}

@Injectable()
export class SubscriptionService {
	url = environment.servicesUrl;
	// Constructor.
	constructor(
		protected dataLayer: DataLayerService,
		private http: HttpClient
	) {}

	// Get ethnicity list.
	public getPlanList(): Observable<ProfessionalPlan[]> {
		const url = `${this.url}/products/professional/plan/list`;
		return this.http.get<ProfessionalPlan[]>(url);
	}

	// Get subscription list.
	public getSubscriptionList(params?: {
		status: string;
	}): Observable<ProfessionalSubscriptionResponse> {
		const url = `${this.url}/products/professional/subscription/list`;
		return this.http.get<ProfessionalSubscriptionResponse>(url, { params });
	}

	// "Cancel" subscription
	public cancelSubscription(
		subscriptionId: ProfessionalSubscription['id'],
		data: { reasons: string[] }
	): Observable<any> {
		const url = `${this.url}/products/professional/subscription/cancel/${subscriptionId}`;
		return this.http.post<any>(url, data);
	}

	// "Undo Cancel" subscription
	public undoCancelation(
		subscriptionId: ProfessionalSubscription['id']
	): Observable<any> {
		const url = `${this.url}/products/professional/subscription/uncancel/${subscriptionId}`;
		return this.http.post<any>(url, {});
	}

	public addToDataLayer(res: ProfessionalSubscriptionResponse) {
		// subscription stuff
		const sub = res.subscriptions.filter(
			(sub) =>
				!['unpaid', 'canceled', 'incomplete_expired'].includes(sub.status)
		);

		if (res.lastPaymentMethod && sub.length) {
			const s = sub[0];
			this.dataLayer.pushToDataLayer({
				isMember: true,
				expiresAt: s.currentPeriodEndsAt,
				paymentPlan: s.planId,
				paymentMethod: res.lastPaymentMethod,
			});
		} else {
			this.dataLayer.pushToDataLayer({
				isMember: false,
			});
		}
	}

	public trackSubscriptionCancellation(
		professionalId: string,
		professionalEmail: string,
		reasons: string[]
	) {
		this.dataLayer.pushToDataLayer({
			event: 'professionalUnsubscribe',
			action: 'click',
			professionalUnsubscribe: {
				id: professionalId,
				email: professionalEmail,
				reason: reasons,
			},
		});
	}
}
